import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { IonicModule, PopoverController } from '@ionic/angular';
import { AuthService } from '../services/auth/auth.service';

@Component({
  selector: 'app-profile-popover',
  templateUrl: './profile-popover.component.html',
  styleUrls: ['./profile-popover.component.scss'],
  standalone: true,
  imports: [IonicModule, RouterLink, RouterLinkActive, CommonModule],
})
export class ProfilePopoverComponent  implements OnInit {

  constructor(
    private popoverController: PopoverController,
    private router: Router,
    private authService: AuthService,
  ) { }

  ngOnInit() {}

  async logout() {
    await this.authService.logout();
    await this.popoverController.dismiss();
  }

  redirectToProfilePage() {
    this.router.navigate([`/perfil/${this.authService.getCurrentUser().uid}`]);
    this.popoverController.dismiss();
  }

}
